import { api } from '@creditsights/api-ui-web';

export const fetchBondCompareExport = async (type: 'text' | 'text-with-diff', ids: string[]): Promise<{ data: File; fileName: string }> => {
  const url = 'common/v1/securities/comparison/covenants/export';
  const response = await api.post(url, { type, ids }, { responseType: 'blob', timeout: 120000 });
  const contentDisposition = response.headers['content-disposition'];
  let fileName = 'ComparationList.xlsx';
  if (contentDisposition) {
    const filenamePar = 'filename="';
    const filenameParInd = contentDisposition.indexOf(filenamePar);
    if (filenameParInd > 0) {
      fileName = contentDisposition.substring(filenameParInd + filenamePar.length);
      if (fileName.charAt(fileName.length - 1) === '"') {
        fileName = fileName.substring(0, fileName.length - 1);
      }
    }
  }

  const { data } = response;

  return { data, fileName };
};
